import * as React from 'react';

import SectionComponent from 'components/common/Section/SectionComponent';
import { LinkContainer } from 'components/common/router';
import Routes from 'routing/Routes';
import { Button, Alert, ButtonToolbar } from 'components/bootstrap';
import { ReadOnlyFormGroup } from 'components/common';
import LicenseCheck from 'license/LicenseCheck';
import getDisplayName from 'authentication/helpers/getDisplayName';
import { AUTH_SERVICE_TYPE } from 'authentication/components/saml/constants';
import type { SAMLBackendFormValues } from 'authentication/components/saml/config/types';

type Props = {
  authenticationBackend: SAMLBackendFormValues;
};

const SAMLTeamSyncConfigSection = ({ authenticationBackend }: Props) => {
  const { id, teamSyncIsCurrentlyEnabled, teamSyncGroupAttributeName, teamSyncAllowedGroups } = authenticationBackend;
  const displayName = getDisplayName(AUTH_SERVICE_TYPE);

  return (
    <SectionComponent
      title="Team Synchronization"
      headerActions={
        <ButtonToolbar>
          <LinkContainer to={Routes.SYSTEM.AUTHENTICATION.BACKENDS.edit(id, 'team_sync')}>
            <Button bsStyle="primary" bsSize="small">
              Edit
            </Button>
          </LinkContainer>
        </ButtonToolbar>
      }>
      {teamSyncIsCurrentlyEnabled ? (
        <LicenseCheck>
          <ReadOnlyFormGroup label="Enabled" value />
          <ReadOnlyFormGroup label="Group Attribute Name" value={teamSyncGroupAttributeName || <em>auto-detect</em>} />
          <ReadOnlyFormGroup label="Allowed Groups" value={teamSyncAllowedGroups || <em>all</em>} />
        </LicenseCheck>
      ) : (
        <Alert>{displayName} team synchronization not configured for this authentication service.</Alert>
      )}
    </SectionComponent>
  );
};

export default SAMLTeamSyncConfigSection;
